{
  "fr": {
    "ticket": {
      "actions": {
        "assignCustomer": "Terminez la procédure",
        "bulk_assign_new_emp": "Attribuer un nouveau responsable en masse",
        "close": "Fermez",
        "create_new": "Créer une nouvelle conversation",
        "customer_new_ticket": "Nouvelle conversation",
        "delete": "Supprimer",
        "edit": "Editer",
        "existing_conversation": "Conversation existante",
        "goToConversation": "Aller à la conversation",
        "move_to_existing": "Déplacer le message vers une conversation existante",
        "new": "Conversation ",
        "new_aria_label": "Entamer une nouvelle conversation",
        "new_conversation": "Nouvelle conversation",
        "reopen": "Rouvrez",
        "selectResponsible": "Sélectionner Responsable",
        "selectUnit": "Sélectionner Unité",
        "show": "Montrez",
        "startNew": "Commencer une nouvelle conversation"
      },
      "attributes": {
        "status": "Statut",
        "statuses": {
          "closed": "Fermée",
          "feedback": "En attente de commentaires",
          "ongoing": "En Cours",
          "open": "Ouverte"
        },
        "title": "Titre"
      },
      "editor": {
        "tooltips": {
          "bold": "Gras",
          "bulletList": "Liste à puces",
          "highlight": "Mise en évidence",
          "italic": "Italique",
          "link": "Lien",
          "orderedList": "Liste numérotée",
          "redo": "Refaire",
          "strike": "Barré",
          "textColor": "Couleur du texte",
          "underline": "Souligner",
          "undo": "Annuler",
          "unlink": "Unlink"
        }
      },
      "labels": {
        "addFile": "Ajouter un fichier",
        "additionalQuestion": "Est-ce que vous avez une autre question?",
        "all": "Tous",
        "allProjects": "Tous les projets",
        "allUnits": "Toutes les unités",
        "assign_conversations": "Attribuer des conversations à partir de",
        "bulk_assign_new_emp_warning": "Cette mise à jour comprendra également les conversations liées aux décisions ou au suivi. Pour les décisions connexes (parmi les conversations concernées), l'employé responsable sera également mis à jour.",
        "cantChangeResponsibleAftercare": "Cette conversation est liée à un ticket de suivi. Veuillez changer le responsable là-bas.",
        "cantChangeResponsibleDecision": "Cette conversation est liée à une décision. Veuillez changer le responsable là-bas.",
        "cantDelete": "Cette conversation appartient à une décision et ne peut pas être supprimée.",
        "cantEdit": "Cette conversation fait partie d'une décision. Modifiez-la plutôt à partir de la décision",
        "changeResponsible": "Modifier",
        "change_responsible": "Changer le responsable des conversations",
        "clientWillRespondSoon": "Nous vous répondra au plus vite possible",
        "contact": "Contact",
        "contactPerson": "Votre contact",
        "contactPersonWithName": "Votre {name} contact",
        "conversation_title": "Titre de la conversation",
        "conversations": "Conversations",
        "create_ticket": "Créer une conversation",
        "customer": "Client",
        "customers": "Clients",
        "decision": "Quelle décision ?",
        "decisionConversation": "Décision",
        "decisionConversations": "Décisions",
        "disabled_unit": "Cette unité a été désactivée. Aucun message ne peut être envoyé.",
        "documentAddedBy": "de",
        "documents": "Documents",
        "email_forwarding": "Transfert d'e-mail",
        "employee": "Collègue",
        "export_conversation": "Exporter conversation",
        "files": "Fichiers",
        "filter": "Filtrer",
        "inbound_by": "Entrant par {name}",
        "inbound_emails": "Courriels entrants",
        "info": "Une question et vous n'avez pas trouvé votre réponse dans la section {faq_route}? Demandez-le ici! Veuillez essayer de regrouper vos questions dans des sujets de conversation clairs, par exemple 'Cahier des charges'.",
        "keywords": "Rechercher du contenu",
        "lastMessage": "Dernier message",
        "message": "Message",
        "message_placeholder": "Écrivez votre message ici...",
        "message_subtitle": "Décrivez votre question ou problème",
        "messaged_at_nulls_first_asc": "Activité la plus ancienne",
        "messaged_at_nulls_last_desc": "Dernière activité",
        "myProjects": "Mes projets",
        "myTickets": "Mes conversations",
        "myTicketsTooltip": "Afficher uniquement les conversations dont vous êtes le responsable",
        "name_lower_asc": "Titre A -> Z",
        "name_lower_desc": "Titre Z -> A",
        "newConversation": "Nouvelle Conversation",
        "newMessage": "Nouveau Message",
        "newMessages": "Nouveau messages",
        "newWithPartner": "Ziggu et {partner}",
        "newWithZiggu": "Seulement Ziggu",
        "noCustomer": "Aucun client assigné ou invité pour l'instant",
        "noCustomerAssignedToUnit": "Aucun client assigné à cette unité. Voulez-vous continuer?",
        "noCustomerAssignedToUnitExplainer": "Notez que vous devrez donc sélectionner un autre récepteur.",
        "noCustomerAssignedToUnit_SUP": "Aucun client n'est affecté à ce projet. Souhaitez-vous continuer ?",
        "noCustomerInvited": "Le client affecté à cette unité n'a pas encore été invité. Voulez-vous continuer ?",
        "noFiles": "Aucun fichier n'a encore été téléchargé",
        "noMessagesYet": "Pas encore de message",
        "noTickets": "Pas de conversations",
        "no_messages": "La conversation est vide",
        "notSeenYet": "Pas encore vu",
        "notYetDetermined": "Pas encore déterminé",
        "note": "Remarque",
        "note_placeholder": "Écrire uniquement aux membres de l'équipe. Tapez {'@'} pour mentionner un membre de l'équipe et il sera notifié.",
        "onlySelect": "Montrer seulement",
        "orNewTicket": "Ou, ouvrez un nouveau sur un sujet différent",
        "otherTickets": "Autres conversations client",
        "participants": "1 participant | {count} participants",
        "partner": "Partenaire",
        "partnerGroup": "Avec qui voulez-vous parler ?",
        "partnersDecision": "Partenaires de décision",
        "pendingContactPerson": "Votre interlocuteur vous répondra dans les meilleurs délais",
        "pendingTickets": "Nouveaux messages",
        "project": "Projet",
        "read": "Lu",
        "remove_inbound_email": "Supprimer {email}?",
        "reply": "Réponse",
        "reply_placeholder": "Écrire à tout le monde",
        "responsible": "Responsable",
        "search": "Rechercher",
        "search_conversation": "Rechercher",
        "seen": "Vu",
        "seenAll": "Tous",
        "seenBy": "Vu par {name}",
        "selectLevel": "Sélectionnez niveau",
        "selectUnit": "Sélectionner l'Unité",
        "show": "Montrant",
        "showFiles": "Afficher les fichiers",
        "showTicketsFor": "Montrer les conversations de",
        "showingAll": "Toutes les conversations",
        "sort": "Sorte par",
        "startConversation": "Démarrer une nouvelle conversation",
        "startConversationForProject": "Lancer une nouvelle conversation dans le projet",
        "startNewConversation": "Démarrer une nouvelle conversation",
        "subject": "Sujet",
        "subject_subtitle": "Décrivez en quelques mots",
        "teamMember": "Collègue",
        "ticketClosed": "Cette conversation a été fermée car elle est terminée.",
        "ticketClosedByResponsible": "Cette conversation a été fermée par {responsible}",
        "ticketClosedCustomer": "Si vous avez une question différente, ouvrez une nouvelle conversation.",
        "ticketClosedEmployee": "Si vous souhaitez rouvrir le ticket, changez le status ci-dessus.",
        "ticket_category": "Catégorie",
        "tickets_all_projects": "Conversations tous les projets",
        "to": "à",
        "unit": "Unité",
        "unit_name_lower_asc": "Unité A -> Z",
        "unit_name_lower_desc": "Unité Z -> A",
        "unread": "Non Lu",
        "upload_files": "1 dossier en cours | {count} dossiers en cours",
        "warning_move_message_to_new_ticket": "Ce message sera déplacé vers une conversation régulière, qui ne sera pas liée à une décision ou à un problème.",
        "withMentions": "Mentionné dans",
        "withMessages": "Avec des messages",
        "writeMessageToBecomeResponsible": "Rédiger un message pour devenir responsable",
        "you": "Vous"
      },
      "messages": {
        "redirect_decision": "Cette conversation fait partie d'une décision. Cliquez ici pour voir la décision.",
        "redirect_issue": "Cette conversation fait partie de l'après-vente. Cliquez ici pour aller à l'après-vente.",
        "redirect_link": "Voir les détails"
      },
      "navigation": {
        "backToTickets": "Retour"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Essayez de regrouper vos questions dans des sujets généraux, par exemple 'Cahier des charges'.",
            "title": "Une question? Demandez le ici!"
          },
          "none": {
            "title": "Aucune conversation trouvée"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Commencez votre première conversation avec quelqu'un!",
            "title": "Quelque chose à demander?"
          },
          "none": {
            "subtitle": "Ajustez les filtres en haut de la page pour trouver les conversations pertinentes.",
            "subtitle_aftercare": "Cliquez sur les 3 points d'un point pour commencer une conversation",
            "title": "Aucune conversation trouvée"
          }
        }
      },
      "toasts": {
        "responsible_updated": "Responsable mis à jour avec succès !"
      },
      "validation": {
        "mustBeMaximum": "Le nom doit avoir au maximum {number} lettres.",
        "needCustomer": "Sélectionner un client",
        "needMessage": "Message requis",
        "needName": "Titre requis",
        "needResponsible": "Sélectionner un responsable",
        "needSubject": "Sujet requis",
        "needUnit": "Sélectionnez une unité"
      }
    }
  }
}
